import { createFileRoute } from '@tanstack/react-router'

import { BlogPostsPage } from '#/modules/content/blog-posts-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/blog-posts/')({
  component: BlogPostsPage,
  validateSearch: validateListSearch,
})
